module.exports = __webpack_public_path__ + "img/ic_login_bg.af343b43.jpg";